import React, { useState, useEffect, useRef } from "react";
import Nav from "./BlueNav";
import { Navigate, useParams } from "react-router-dom";
import Footer from "./Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faTwitter,
  faLinkedin,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import {
  faStar,
  faHotel,
  faCar,
  faPersonHiking,
  faTag,
  faSun, faChevronDown,
  faLocation,
  faLocationPin,
  faCalendar,
  faLocationDot,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import "./PackageDestination.css";
import Seo from "../Seo/Seo";
import { toMetaDescription, useCanonicalUrl } from "../Seo/seoUtils";
import { buildPackageJsonLd } from "../Seo/jsonLd";
import { SITE_NAME } from "../Seo/seoConfig";
import NotFound from "../NotFound/NotFound";

const PackageDestination = () => {
  const { id } = useParams();
  const { slug } = useParams();
  const canonicalUrl = useCanonicalUrl();
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Kept separate from `error` so a failed/unreachable API request isn't
  // reported to the visitor as "this page doesn't exist".
  const [notFound, setNotFound] = useState(false);
  const [currentDetail, setCurrentDetail] = useState("overview"); // Default detail to show
  const [destinations, setDestinations] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState("");
  const [activeItem, setActiveItem] = useState(null); // State to track active accordion item
  const [packageId, setPackageId] = useState("");
  const [isOverviewActive, setIsOverviewActive] = useState(true);
  const [widgetData, setWidgetData] = useState(null); // State to hold widget data
  const [showWidget, setShowWidget] = useState(false); // Default to false

  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const whereToGoRef = useRef(null);
  const countryCodeRef = useRef(null);
  const phoneNoRef = useRef(null);
  const messageRef = useRef(null);
  const getQuoteButtonRef = useRef(null);
  console.log("sluggf", slug);
  const fetchPackageData = async () => {
    setLoading(true);
    setError(null);
    setNotFound(false);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}AllPackages`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const responseData = await response.json();
      console.log("responseData", responseData);

      const packageData = responseData.data.find(
        (item) => item.slug === slug
      );
      console.log("packageData", packageData);

      if (!packageData) {
        setNotFound(true);
        return;
      }

      setSelectedPackage(packageData);
      setPaymentDetails(packageData.PaymentDetails || "");
      setPackageId(packageData.id || "");

      if (packageData.Visit && packageData.Visit.length > 0) {
        setWidgetData(packageData.Visit[0]);
        setShowWidget(true);
      } else {
        setShowWidget(false);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (slug) {
      fetchPackageData();
    }
  }, [slug]);


  // added -->
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      Name: nameRef.current.value,
      Email: emailRef.current.value,
      Phone: phoneNoRef.current.value,
      WhereToGo: whereToGoRef.current.value,
      Message: messageRef.current.value,
      PackageId: packageId, // Include the package ID in the form data
    };
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}PackageQoutes`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to submit form data");
      }
      const responseData = await response.json();
      console.log("Form submission successful:", responseData);
      // Reset form fields if needed
      nameRef.current.value = "";
      emailRef.current.value = "";
      phoneNoRef.current.value = "";
      whereToGoRef.current.value = "";
      messageRef.current.value = "";
    } catch (error) {
      console.error("Error submitting form data:", error);
    }
  };

  //--->

  // Fetch data from API

  // ------------------->> All  Destinations

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}AllDestination`
        );
        const data = await response.json();
        console.log("data of AllDEst Neeche wala", data);
        if (data.status === "true") {
          setDestinations(data.data);
        } else {
          console.error("Error fetching data:", data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  // ------------------->> All  Destinations
  // Function to chunk destinations into groups of 4
  const chunkArray = (array, size) => {
    const chunkedArray = [];
    for (let i = 0; i < array.length; i += size) {
      chunkedArray.push(array.slice(i, i + size));
    }
    return chunkedArray;
  };
  const handleButtonClick = (detail) => {
    setCurrentDetail(detail);
    setIsOverviewActive(detail === "overview"); // Update isOverviewActive based on the clicked button
    fetchPackageData(detail);
  };

  useEffect(() => {
    fetchPackageData(currentDetail);
  }, [id, currentDetail]);

  const handleGetQuoteClick = () => {
    nameRef.current.focus();
  };

  const handleAccordionClick = (index) => {
    setActiveItem(activeItem === index ? null : index); // Toggle active item
  };


  useEffect(() => {
    // Load the widget script dynamically here based on widgetData
    if (showWidget && widgetData) {
      const script = document.createElement("script");
      script.src = widgetData.scriptUrl; // Assuming widgetData has a scriptUrl field
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, [showWidget, widgetData]);


  const handleBookOnline = () => {
    sessionStorage.setItem("slugg", slug);
    const categoryId = selectedPackage ? selectedPackage.category.id : null;
    console.log("IDDD-", categoryId);
    if (categoryId === 3) {
      window.location.href = "/book-online";
    } else {
      window.location.href = "/book-online-car-Hotel";
    }
  };


  // Guard against showing the previous package's SEO tags while a new
  // slug's data is still loading (e.g. navigating package A -> package B).
  const currentPackage =
    selectedPackage && selectedPackage.slug === slug ? selectedPackage : null;

  // Hotel/bike/car packages have a canonical page at
  // /detail-{hotel,bike,car}-package/{name-slug} (DetailHotelPackage.jsx /
  // DetailBikePackage.jsx / DetailCarPackage.jsx). Serving them again here
  // at the bare /{slug} URL duplicated that page under a second URL, so
  // that case 404s instead of rendering. Category matching mirrors
  // ApiController@generateSitemap exactly: hotel = category.name ===
  // "hotels" (case-insensitive), bike = category.name contains "bike"
  // (case-insensitive), car = category.name contains "Cars tour"
  // (case-sensitive).
  const categoryName = currentPackage?.category?.name || "";
  const isDuplicatePackagePage =
    Boolean(currentPackage) &&
    (categoryName.toLowerCase() === "hotels" ||
      categoryName.toLowerCase().includes("bike") ||
      categoryName.includes("Cars tour"));

  // No package behind this slug: the URL simply doesn't exist. "/:slug" is the
  // router's catch-all for single-segment URLs, so this is where most 404s on
  // the site actually land.
  if (isDuplicatePackagePage || notFound) {
    return <NotFound />;
  }

  return (
    <>
      <Seo
        title={
          currentPackage
            ? currentPackage.meta_title || `${currentPackage.name} | ${SITE_NAME}`
            : undefined
        }
        description={
          currentPackage
            ? currentPackage.meta_description || toMetaDescription(currentPackage.overview, 160)
            : undefined
        }
        image={currentPackage?.image?.[0]}
        type="product"
        jsonLd={currentPackage ? buildPackageJsonLd(currentPackage, canonicalUrl) : null}
        noindex={Boolean(error)}
      />
      <div className="container p-0">
        <Nav />
        <h3 className="text-center mt-5 pt-0 pt-md-5">
          <b>{selectedPackage && selectedPackage.name}</b>
        </h3>

        <div className="row mt-5 mx-3">
          <div className="col-lg-8">
            {loading && <p>Loading...</p>}
            {error && <p>Error: {error}</p>}
            {selectedPackage && (
              <>
                <div
                  className="custom-carousel-container"
                  style={{ borderRadius: "10px", overflow: "hidden" }}
                >
                  <div
                    id="carouselExampleInterval"
                    className="carousel slide"
                    data-ride="carousel"
                  >
                    <div className="carousel-inner">
                      {(Array.isArray(selectedPackage.image) ? selectedPackage.image : []).map((img, index) => (
                        <div
                          key={index}
                          className={`carousel-item ${index === 0 ? "active" : ""
                            }`}
                          data-interval="10000"
                        >
                          <img
                            src={`${img}`}
                            className="d-block w-100"
                            style={{ maxHeight: "400px", objectFit: "cover" }}
                            alt={`Slide ${index}`}
                          />
                        </div>
                      ))}
                    </div>
                    <a
                      className="carousel-control-prev"
                      href="#carouselExampleInterval"
                      role="button"
                      data-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span className="sr-only">Previous</span>
                    </a>
                    <a
                      className="carousel-control-next"
                      href="#carouselExampleInterval"
                      role="button"
                      data-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span className="sr-only">Next</span>
                    </a>
                  </div>
                </div>

                <div className="d-flex gap-4 flex-wrap mt-5 mb-3">
                  <button
                    className={`btn custom-btn ${currentDetail === "overview" ? "active" : ""
                      }`}
                    onClick={() => handleButtonClick("overview")}
                    style={{
                      backgroundColor:
                        currentDetail === "overview" ? "#03045E" : "",
                      color: currentDetail === "overview" ? "#FFFFFF" : "",
                    }}
                  >
                    Overview
                  </button>
                  {selectedPackage.category.heading === "Hotel Bookings" ? (
                    <button
                      className={`btn custom-btn ${currentDetail === "hotel_highlight" ? "active" : ""
                        }`}
                      onClick={() => handleButtonClick("hotel_highlight")}
                      style={{
                        backgroundColor:
                          currentDetail === "hotel_highlight" ? "#03045E" : "",
                        color:
                          currentDetail === "hotel_highlight" ? "#FFFFFF" : "",
                      }}
                    >
                      Hotel Highlight
                    </button>
                  ) : (
                    <button
                      className={`btn custom-btn ${currentDetail === "trip_highlight" ? "active" : ""
                        }`}
                      onClick={() => handleButtonClick("trip_highlight")}
                      style={{
                        backgroundColor:
                          currentDetail === "trip_highlight" ? "#03045E" : "",
                        color:
                          currentDetail === "trip_highlight" ? "#FFFFFF" : "",
                      }}
                    >
                      Trip Highlight
                    </button>
                  )}

                  {selectedPackage.category.heading !== "Hotel Bookings" && (
                    <button
                      className={`btn custom-btn ${currentDetail === "itinerary_details" ? "active" : ""
                        }`}
                      onClick={() => handleButtonClick("itinerary_details")}
                      style={{
                        backgroundColor:
                          currentDetail === "itinerary_details"
                            ? "#03045E"
                            : "",
                        color:
                          currentDetail === "itinerary_details"
                            ? "#FFFFFF"
                            : "",
                      }}
                    >
                      Itinerary Detail
                    </button>
                  )}

                  <button
                    ref={getQuoteButtonRef}
                    className={`btn custom-btn ${currentDetail === "get_quote" ? "active" : ""
                      }`}
                    onClick={() => handleButtonClick("get_quote")}
                    style={{
                      backgroundColor:
                        currentDetail === "get_quote" ? "#03045E" : "",
                      color: currentDetail === "get_quote" ? "#FFFFFF" : "",
                    }}
                  >
                    Get Quote
                  </button>
                </div>

                <div
                  className="align-items-center p-2 mb-2"
                  style={{
                    borderStyle: "dotted",
                    borderRadius: "15px",
                    borderColor: "#CAF0F8",
                  }}
                >
                  <div className="d-inline-flex align-items-center p-2">
                    <FontAwesomeIcon
                      icon={faLocationDot}
                      style={{ marginRight: "8px" }}
                    />
                    <span style={{ color: "#03045E" }}>
                      <h5 className="mb-0">
                        <b>Destination Covered :</b>
                      </h5>
                    </span>
                  </div>
                  <div
                    className="align-items-center"
                    style={{ color: "#666666", paddingLeft: "30px" }}
                  >
                    <b>{selectedPackage && selectedPackage.location}</b>
                  </div>
                  <div className="ms-2">
                    <div className="d-flex align-items-center">
                      <FontAwesomeIcon icon={faCalendar} />{" "}
                      <span className="ms-2" style={{ color: "black" }}>
                        <h5 style={{ color: "blue", marginTop: "10px" }}>
                          <b style={{ color: "#03045E" }}>
                            Available Tour Dates
                          </b>
                        </h5>
                      </span>
                    </div>
                    <div className="d-flex flex-wrap">
                      {selectedPackage && selectedPackage.category.id === 3 ? (
                        selectedPackage.TourDate.map((date, index) => (
                          <p
                            key={index}
                            style={{ color: "#666666", paddingLeft: "20px" }}
                          >
                            <b>{date}</b>
                          </p>
                        ))
                      ) : (
                        <p style={{ color: "#666666", paddingLeft: "20px" }}>
                          <b>
                            You can select your Dates at the time of Booking
                          </b>
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* ------------ Destination Covered end -------*/}

                <div className="details-container">
                  {currentDetail === "overview" && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: selectedPackage.overview,
                      }}
                    ></div>
                  )}

                  {/* Trip Highlight */}
                  {currentDetail === "trip_highlight" && (
                    <div>
                      {selectedPackage.trip_highlight.map(
                        (highlight, index) => (
                          <div
                            key={index}
                            className="d-flex align-items-center mb-3 p-3"
                            style={{
                              marginTop: "8px",
                              border: "1.35px solid #0000001A",
                              boxShadow: "1px 1px 2px 0px #0000001A",
                              borderRadius: "8px",
                            }}
                          >
                            <div className="me-2">
                              <FontAwesomeIcon icon={faTag} />
                            </div>
                            <div>{highlight}</div>
                          </div>
                        )
                      )}
                    </div>
                  )}

                  {currentDetail === "hotel_highlight" &&
                    selectedPackage &&
                    selectedPackage.trip_highlight && (
                      <div>
                        {selectedPackage.trip_highlight.map(
                          (highlight, index) => (
                            <div
                              key={index}
                              className="d-flex align-items-center mb-3 p-3"
                              style={{
                                marginTop: "8px",
                                border: "1.35px solid #0000001A",
                                boxShadow: "1px 1px 2px 0px #0000001A",
                                borderRadius: "8px",
                              }}
                            >
                              <div className="me-2">
                                <FontAwesomeIcon icon={faHotel} />
                              </div>
                              <div>{highlight}</div>
                            </div>
                          )
                        )}
                      </div>
                    )}

                  {/* --------------> */}

                  {/* Itenary */}

                  {/* {currentDetail === "itinerary_details" &&
                    selectedPackage.intinerary_details && (
                      <div id="accordionItinerary" className="accordion">
                        {selectedPackage.intinerary_details.map(
                          (detailsArray, outerIndex) => (
                            <div
                              className="accordion-item mb-3"
                              key={outerIndex}
                              style={{
                                backgroundColor: "#EFF1F6",
                              }}
                            >
                              {detailsArray && detailsArray[0] && (
                                <div key={outerIndex} className="row">
                                  
                                  <div className="col-2">
                                    <button
                                      className="btn btn-primary"
                                      style={{
                                        width: "100%",
                                        height: "52px",
                                        color: "#FFFFFF",
                                        border: "none",
                                      }}
                                    ><small>
                                       <FontAwesomeIcon icon={faSun} /> Day{" "}
                                       {outerIndex + 1}
                                    </small>
                                     
                                    </button>
                                  </div>
                                  
                                  <div className="col-10">
                                    <h2
                                      className="accordion-header"
                                      id={`headingItinerary${outerIndex}`}
                                    >
                                      <button
                                        className={`accordion-button ${activeItem === outerIndex
                                          ? "active"
                                          : ""
                                          }`}
                                        type="button"
                                        onClick={() =>
                                          handleAccordionClick(outerIndex)
                                        } 
                                        aria-expanded={
                                          activeItem === outerIndex
                                            ? "true"
                                            : "false"
                                        }
                                        aria-controls={`collapseItinerary${outerIndex}`}
                                      >
                                        {detailsArray[0]}
                                      </button>
                                    </h2>
                                    <div
                                      id={`collapseItinerary${outerIndex}`}
                                      className={`accordion-collapse collapse ${activeItem === outerIndex ? "show" : ""
                                        }`} 
                                      aria-labelledby={`headingItinerary${outerIndex}`}
                                      data-bs-parent="#accordionItinerary"
                                    >
                                      <div className="accordion-body">
                                        <p>{detailsArray[1]}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          )
                        )}
                      </div>
                    )} */}

                    {currentDetail === "itinerary_details" &&
  selectedPackage.intinerary_details && (
    <div id="accordionItinerary" className="accordion">
      {selectedPackage.intinerary_details.map((detailsArray, outerIndex) => (
        <div
          className="accordion-item mb-3"
          key={outerIndex}
          style={{
            backgroundColor: "#EFF1F6",
          }}
        >
          {detailsArray && detailsArray[0] && (
            <div key={outerIndex} className="row align-items-start">
              {/* Day Button */}
              <div className="col-12 col-sm-2 mb-2 mb-sm-0">
                <button
                  className="btn btn-primary d-flex justify-content-center align-items-center w-100"
                  style={{
                    height: "52px",
                    color: "#FFFFFF",
                    border: "none",
                    display: "flex", // Ensures the content remains centered
                    alignItems: "center", // Ensures the content remains vertically aligned
                    justifyContent: "center", // Ensures content is centered horizontally
                  }}
                >
                  <small>
                    <FontAwesomeIcon icon={faSun} /> Day {outerIndex + 1}
                  </small>
                </button>
              </div>

              {/* Accordion Header and Collapse */}
              <div className="col-12 col-sm-10">
                <h2
                  className="accordion-header"
                  id={`headingItinerary${outerIndex}`}
                >
                  <button
                    className={`accordion-button d-flex justify-content-between align-items-center ${activeItem === outerIndex
                      ? "active"
                      : ""
                      }`} // Toggle active class
                    type="button"
                    onClick={() => handleAccordionClick(outerIndex)} // Handle click event
                    aria-expanded={activeItem === outerIndex ? "true" : "false"}
                    aria-controls={`collapseItinerary${outerIndex}`}
                    // style={{
                    //   display: "flex", // Use flexbox for consistent alignment
                    //   justifyContent: "space-between", // Ensure content stays aligned
                    //   alignItems: "center", // Vertically center the content
                    //   padding: "0.5rem 1rem", // Add padding to avoid content sticking to edges
                    // }}
                  >
                    {detailsArray[0]}
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      style={{
                        transition: "transform 0.3s",
                        transform:
                          activeItem === outerIndex
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                      }}
                    />
                  </button>
                </h2>
                <div
                  id={`collapseItinerary${outerIndex}`}
                  className={`accordion-collapse collapse ${activeItem === outerIndex ? "show" : ""
                    }`} // Toggle show class
                  aria-labelledby={`headingItinerary${outerIndex}`}
                  data-bs-parent="#accordionItinerary"
                >
                  <div className="accordion-body">
                    <p>{detailsArray[1]}</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  )}
                  {/* ----------------> */}
                </div>
              </>
            )}
          </div>

          <div className="col-lg-4 ps-0 ps-md-4">
            {/* PaymentDetails Card */}
            <div
              className="card"
              style={{
                boxShadow:
                  "-1.4294641017913818px 1.4294641017913818px 14.29464054107666px 7.14732027053833px #00000014",
                border: "1px solid #00000008",
                borderStyle: "none",
              }}
            >
              <div className="card-body">
                <div className="d-flex gap-2 align-items-center">
                  <span className="card-title text-primary h4 fw-bold text-left w-75">
                    {selectedPackage && selectedPackage.name}{" "}
                  </span>

                  {selectedPackage && selectedPackage.category_id !== 1 && (
                    <span
                      className="text-white p-2 rounded"
                      style={{ fontSize: "15px", background: "#03045E" }}
                    >
                      <FontAwesomeIcon icon={faSun} />{" "}
                      {selectedPackage && selectedPackage.days} Days Tour
                    </span>
                  )}
                </div>
                <hr />
                <div
                  className="card-text"
                  dangerouslySetInnerHTML={{ __html: paymentDetails }}
                ></div>

                <h4 style={{ color: "#03045E" }}>
                  Rs.{" "}
                  <b>
                    {selectedPackage &&
                      (selectedPackage.category_id === 1
                        ? selectedPackage.price[0]
                        : selectedPackage.price)}
                    /-
                  </b>{" "}
                  {/* <small>
    {selectedPackage && selectedPackage.category_id === 1
      ? "Per Night "
      : "Per Person"}
  </small> */}
                  <small>
                    {selectedPackage && selectedPackage.category_id === 1 ? (
                      <>
                        {" "}
                        Night{" "}
                        <span style={{ fontSize: "0.8em" }}>
                          (Double Sharing)
                        </span>{" "}
                        <br></br>
                        <small style={{ fontSize: "0.7em", color: "red" }}>
                          (*food Included*)
                        </small>
                      </>
                    ) : (
                      "Per Person"
                    )}
                  </small>
                </h4>
              </div>
            </div>
            {/* Buttonn Book Online */}

            <div className="mt-4" style={{ borderRadius: "57.03px" }}>
              {/* <Link
                to="#"
                className="btn w-100 btn-primary"
                style={{ borderRadius: "50px" }}
                onClick={handleBookOnline}
              >
                Book Online
              </Link> */}
              <a
                href="tel:9149516495"
                className="btn btn-primary d-flex align-items-center justify-content-center "
              >
                Book
                <i className="bi bi-telephone ms-2"></i>
              </a>

            </div>

            {/* Share This Trip */}

            <div className="mt-5 text-center" style={{ color: "#03045E" }}>
              <h5>Share This Trip</h5>
              <div>
                <a
                  href="https://www.facebook.com/profile.php?id=100088895292951&mibextid=ZbWKwL"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon className="me-2 h4" icon={faFacebook} />
                </a>

                <a
                  href="https://www.instagram.com/travellers_choice_ladakh/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon className="me-2 h4" icon={faInstagram} />
                </a>

                <a
                  href="https://www.linkedin.com/in/your-linkedin-url"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon className="me-2 h4" icon={faLinkedin} />
                </a>
              </div>
            </div>

            {/* Enquiry */}
            <div
              className="card mt-5"
              style={{
                boxShadow:
                  "-1.3534338474273682px 1.3534338474273682px 13.534337997436523px 6.767168998718262px rgba(219, 226, 247, 0.55)",
                borderRadius: "20px",
                color: "#03045E",
                borderStyle: "none",
              }}
            >
              <div className="card-body text-center">
                <h4 className="card-title">
                  <b>Enquiry</b>
                </h4>
                <h6 className="card-subtitle mb-2 ">
                  Want to know more contact us
                </h6>
                <h5>
                  <FontAwesomeIcon icon={faPhone} />{" "}
                  <a
                    style={{ color: "#03045E", textDecoration: "none" }}
                    href="tel:+91 9149516495"
                  >
                    +91 9149516495
                  </a>
                </h5>
              </div>
            </div>

            {/* Form */}
            <div
              className="card mt-3"
              style={{
                backgroundColor: "#F6F7FC",
                boxShadow:
                  "-1.3534338474273682px 1.3534338474273682px 13.534337997436523px 6.767168998718262px rgba(219, 226, 247, 0.55)",
                borderRadius: "20px",
                padding: "20px",
                borderStyle: "none",
              }}
            >
              <div className="card-body text-center">
                <p>
                  <span style={{ color: "red" }}>*</span>Leave a message and
                  We'll get back to you
                </p>
                <form>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your Name"
                      ref={nameRef}
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email Address"
                      ref={emailRef}
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Where to go?"
                      ref={whereToGoRef}
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Country Code"
                      ref={countryCodeRef}
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="Phone No"
                      ref={phoneNoRef}
                    />
                  </div>
                  <div className="mb-3">
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Write a message"
                      ref={messageRef}
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    onClick={handleSubmit}
                  >
                    <b>Submit</b>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Adding Widgets */}

        <div>
          {showWidget && widgetData && (
            <div>
              <h3 className="my-4" style={{ color: "#03045E" }}>
                <b>Explore More</b>
              </h3>
              {/* Render the widget container based on widgetData */}
              <div dangerouslySetInnerHTML={{ __html: widgetData.html }} />
            </div>
          )}
        </div>
        {/* Ladakh Tour Package */}

        <div className="container">
          <div className="col-12">
            <h3 className="mt-5 mb-3 text-center">Trending Ladakh Tour Packages</h3>
            <div>
              <div className="row mt-2 row-cols-1 row-cols-md-2 row-cols-lg-4 g-4"> {/* Added g-4 for spacing between cards */}
                {destinations.slice(0, 4).map((destination) => (
                  <div key={destination.id} className="col-lg-3 col-md-6 col-sm-12" >
                    <div
                      className="card border-0 rounded m-2"
                      style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)" }}
                    >
                      <img
                        src={destination.Image}
                        className="card-img-top rounded"
                        style={{ height: "250px", objectFit: "cover" }}
                        alt={destination.Name}
                      />
                      <div className="card-body">
                        <h6
                          className="card-title d-flex align-items-center justify-content-between"
                          style={{ fontSize: "18px" }}
                        >
                          {destination.Name}{" "}
                          <span>
                            <FontAwesomeIcon
                              style={{ color: "#ffd049" }}
                              icon={faStar}
                            />
                            <span style={{ fontSize: "14px", marginLeft: "5px" }}>
                              {destination.Rating}
                            </span>
                          </span>
                        </h6>
                        <p style={{ opacity: "0.5", fontSize: "14px" }}>
                          {destination.Day} Days & {destination.Night} Nights
                        </p>
                        <div className="row">
                          <div
                            className="col-4 d-flex flex-column align-items-center"
                            style={{ opacity: "0.5" }}
                          >
                            <FontAwesomeIcon
                              icon={faHotel}
                              style={{ color: "#000000" }}
                            />
                            <span style={{ marginTop: "0.5rem", fontSize: "12px" }}>
                              {destination.Activities[0]} Hotels
                            </span>
                          </div>

                          <div
                            className="col-4 d-flex flex-column align-items-center"
                            style={{ opacity: "0.5" }}
                          >
                            <FontAwesomeIcon icon={faCar} />
                            <span style={{ marginTop: "0.5rem", fontSize: "12px" }}>
                              {destination.Activities[1]} Transfers
                            </span>
                          </div>

                          <div
                            className="col-4 d-flex flex-column align-items-center"
                            style={{ opacity: "0.5" }}
                          >
                            <FontAwesomeIcon icon={faPersonHiking} />
                            <span style={{ marginTop: "0.5rem", fontSize: "12px" }}>
                              {destination.Activities[2]} Activities
                            </span>
                          </div>
                        </div>
                        <div
                          className="mt-2"
                          style={{
                            textAlign: "left",
                            opacity: "0.5",
                            fontSize: "13px",
                          }}
                        >
                          <span
                            dangerouslySetInnerHTML={{
                              __html: destination.Details,
                            }}
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="text-center mt-4 mb-2">
                <button
                  className="btn btn-primary"
                  onClick={() => (window.location.href = "/ladakh-dest")}
                >
                  View More
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default PackageDestination;
